export interface WindowLocation {
  href: string;
  assign: (url: string) => void;
  replace: (url: string) => void;
}

export interface WindowHelper {
  location: WindowLocation;
}

const windowHelper: WindowHelper = {
  location: {
    assign: (url: string): void => window.location.assign(url),
    href: window.location.href,
    replace: (url: string): void => window.location.replace(url),
  },
};

export default windowHelper;
